import { Injectable } from '@angular/core';
import { CdnDomain } from "@vshosting/models";
import { ApiEntityKeys } from '../../app.constant';
import { DomainAddPayload, DomainUpdatePayload } from './domain-base.model';
import { EntityService } from '@vshosting/core';

@Injectable({ providedIn: 'root' })
export class DomainEntity extends EntityService<CdnDomain, DomainAddPayload, DomainUpdatePayload> {
  constructor() {
    super(ApiEntityKeys.Domain);
  }
}
